<div class="body">
    <br />

    <br />
    <div class="row">
        <div class="col-lg-1"> </div>

        <div class="col-lg-3"> <label> Observaciones </label> </div>

        <div class="col-lg-8">
            <mat-form-field appearance="outline" class="example-full-width">
                <textarea name="observacion" id="observacion" matInput cols="150" rows="5"
                [maxlength]="500" [(ngModel)]="afiliado.observacion" placeholder="Ingrese una observación (max. 500 caracteres)"
                    (ngModelChange)="$event.toUpperCase()">{{afiliado.observacion}}</textarea>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-2"> </div>

        <div class="col-lg-1"> </div>

        <div class="col-lg-2">
            <button class="btn btn-info" id="btnvalida" (click)="historicosObservaciones()">
                Historicos
            </button>
        </div>
      
        <div class="col-lg-2"  *ngIf="rol === 'ROLE_ADMIN' || rol === 'ROLE_ENCARGADO_CONTABILIDAD'">
            <button class="btn btn-success" id="btnvalida" (click)="guardar()">
                Guardar Observación
            </button>
        </div>
       
    </div>



</div>

<!--/form-->